module.exports = __webpack_public_path__ + "static/img/10030.593cc22a.png";